export const EwayBillActions = {
    FETCH_LMVRID_DETAILS: "FETCH_LMVRID_DETAILS",
    SET_LMVRID_DETAILS: "SET_LMVRID_DETAILS",
    DOWNLOAD_EWAYBILL: "DOWNLOAD_EWAYBILL",
    DOWNLOAD_EWAYBILL_RESPONSE: "DOWNLOAD_EWAYBILL_RESPONSE",
    SET_ERROR_WHILE_FETCHING_LMVRIDS: "SET_ERROR_WHILE_FETCHING_LMVRIDS",
    SET_ERROR_WHILE_FETCHING_EWAYBILL: "SET_ERROR_WHILE_FETCHING_EWAYBILL",
    SET_ERROR_WHILE_CREATING_PDF: "SET_ERROR_WHILE_CREATING_PDF"
}


// WEBPACK FOOTER //
// ./src/components/eWayBill/actions/EwayBillActions.js